import { useQuery } from '@tanstack/react-query';

import type {
  MonthlyIncomeParams,
  MonthlyIncomeResponseData,
  SuccessResponseWithError,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const MONTHLY_INCOME_QUERY_KEY = 'monthly_income';

export const useMonthlyIncomeQuery = (params: MonthlyIncomeParams) =>
  useQuery({
    queryKey: [MONTHLY_INCOME_QUERY_KEY, params.url, params.queryParams],
    queryFn: () =>
      HttpClient.request<MonthlyIncomeResponseData | SuccessResponseWithError>({
        method: 'GET',
        url: params.url,
        params: params.queryParams,
      }),
    refetchOnWindowFocus: false,
    gcTime: 0,
    staleTime: 0,
    retry: false,
  });
